<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h6 class="prd-h6"> Assessor Dictionaries</h6>
<div class="card">
  <br />
  <div class="row">
    <label for='dictType' class="col-md-1 prd-label">Dictionary</label>
    <div class="col-md-1">
      <select [(ngModel)] = 'dictType' id="dictType" class="prd-required" (change)="onChangeType()">
        <option></option>
        <option *ngFor="let dt of dictTypeList" [ngValue]="dt.id" >{{ dt.desc }}</option>
      </select>
  </div>

  <div class="card-body" *ngIf = 'displayState.workingDiv'>
    <div class="row" >
      <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
    </div>
  </div>
</div>
<br />
<div class="card-body" *ngIf="displayState.crewDiv">
  <div class="row">
      <div class="col-md-2 offset-1">
        <button class="btn btn-sm btn-link" (click)="newCrew()" [hidden]="displayState.crewEntryDiv">New Crew</button>
      </div>
  </div>
  <div class="row">
    <div class="col-md-10 offset-1">
      <p-table [value]="crewList" [scrollable]="true" scrollHeight="300px">
        <ng-template pTemplate="header">
          <tr style="font-size:smaller">
            <th style="width: 10%" >&nbsp;</th>
            <th [pSortableColumn]="'crew'" style="width: 20%" >
            Crew
              <p-sortIcon [field]="'crew'"></p-sortIcon>
            <th style="width: 10%" >&nbsp;</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr style="font-size: small;">
            <td style="width: 10%">
              <button class='btn btn-sm btn-link' (click)="onSelect(item)" >Select</button>
            </td>
            <td style="width: 20%">{{item.crew}}</td>
            <td style="width: 10%">
              <button class='btn btn-sm btn-link' (click)="deleteEntry(item)" >Delete</button>
            </td>

          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="card-body" *ngIf="displayState.crewEntryDiv">
  <hr />
  <div class="row">
    <label class="control-label col-md-1 control-label-appeals">Crew</label>
    <div class="col-md-6">
      <input type="text" class="form-control form-appeals" [(ngModel)]="myEntry.crew">
    </div>
  </div>
  <br />
  <!-- Buttons -->
  <div class="row">
    <div class="offset-1 col-md-9">
      <button type="submit" class="btn btn-success" (click)="saveEntry()">Save</button>
      <button type="submit" class="btn btn-cancel" (click)="cancelEntry()">Cancel</button>
    </div>
  </div>
</div>

<div class="card-body" *ngIf="displayState.divisionDiv">
  <div class="row">
    <div class="col-md-2 offset-1">
      <button class="btn btn-sm btn-link" (click)="newDivision()" [hidden]="displayState.divisionEntryDiv">New Division</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-10 offset-1">
      <p-table [value]="divisionList" [scrollable]="true" scrollHeight="540px"  >
        <ng-template pTemplate="header">
          <tr style="font-size:smaller">
            <th style="width: 10%" >&nbsp;</th>
            <th [pSortableColumn]="'division'" style="width: 20%" >
              Division
              <p-sortIcon [field]="'division'"></p-sortIcon>
            <th style="width: 10%" >&nbsp;</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr style="font-size: small;">
            <td style="width: 10%">
              <button class='btn btn-sm btn-link' (click)="onSelect(item)" >Select</button>
            </td>
            <td style="width: 20%">{{item.division}}</td>
            <td style="width: 10%">
              <button class='btn btn-sm btn-link' (click)="deleteEntry(item)" >Delete</button>
            </td>

          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>
<div class="card-body" *ngIf="displayState.divisionEntryDiv">
  <hr />
  <div class="row">
      <label class="control-label col-md-1 control-label-appeals">Division</label>
      <div class="col-md-6">
        <input type="text" class="form-control form-appeals" [(ngModel)]="myEntry.division">
      </div>
  </div>
  <br />
    <!-- Buttons -->
    <div class="row">
      <div class="offset-1 col-md-9">
        <button type="submit" class="btn btn-success" (click)="saveEntry()">Save</button>
        <button type="submit" class="btn btn-cancel" (click)="cancelEntry()">Cancel</button>
      </div>
  </div>
</div>
<div class="card-body" *ngIf="displayState.specialCaseDiv">
  <div class="row">
    <div class="col-md-2 offset-1">
      <button class="btn btn-sm btn-link" (click)="newSpecialCase()" [hidden]="displayState.specialCaseEntryDiv">New Special Case Type</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-10 offset-1">
      <p-table [value]="specialCaseList" [scrollable]="true" scrollHeight="540px"  >
        <ng-template pTemplate="header">
          <tr style="font-size:smaller">
            <th style="width: 10%" >&nbsp;</th>
            <th [pSortableColumn]="'specialCase'" style="width: 20%" >
              Special Case Type
              <p-sortIcon [field]="'specialCase'"></p-sortIcon>
            <th style="width: 10%" >&nbsp;</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr style="font-size: small;">
            <td style="width: 10%">
              <button class='btn btn-sm btn-link' (click)="onSelect(item)" >Select</button>
            </td>
            <td style="width: 20%">{{item.specialCase}}</td>
            <td style="width: 10%">
              <button class='btn btn-sm btn-link' (click)="deleteEntry(item)" >Delete</button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="card-body" *ngIf="displayState.specialCaseEntryDiv">
  <hr />
  <div class="row">
      <label class="control-label col-md-1 control-label-appeals">Special Case</label>
      <div class="col-md-6">
        <input type="text" class="form-control form-appeals" [(ngModel)]="myEntry.specialCase">
      </div>
  </div>
  <br />
    <!-- Buttons -->
  <div class="row">
    <div class="offset-1 col-md-9">
      <button type="submit" class="btn btn-success" (click)="saveEntry()">Save</button>
      <button type="submit" class="btn btn-cancel" (click)="cancelEntry()">Cancel</button>
    </div>
  </div>
</div>
</div>
